<template>
    <div class="templete no_print">
        <div class="path_title clearfix">
            <span class="path_title_name">销售单折扣价格是否开启</span>
        </div>
        <!-- <div class="path_title">销售单锁定等级设置</div> -->
        <div class="path_switch">
            <el-radio-group v-model="radioGrade" @change="gradeChange">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
        </div>
        </div>
</template>
<style scoped lang="scss">
    .contractLabel{float: left;position: relative;top:3px;margin-left:10px;}
    .path_title_name{float: left;}
    .redQuestion{display: block;width:15px;height:15px;background: url('/icon/question.png') no-repeat 100%;background-size: 100% 100%;}
    .labelTip{display: none;position: absolute;top:20px;left:-150px;z-index:1;width:200px;text-align: left;background-color: #b21111;border-radius: 4px;padding:10px;box-sizing: border-box;}
    .laCbelTipC{color:white;font-size: 12px;}
    .contractLabel:hover{cursor: pointer;}
    .contractLabel:hover .labelTip{display: block;}
    .path_title{text-align: left;
        font-size:16px; font-weight:bold; margin-top: 26px;margin-bottom:20px;
        & + div{ margin-bottom: 20px; color: #333333; display: flex; align-items: center; }
    }
    .input_box{ width:80px; margin: 0 10px; }
    .container{
        padding: 34px 30px; display: flex; flex-direction: column; align-items: stretch; text-align: left; height: 100%; background-color: #fff; border-top:8px solid #EEEFF2; border-left:12px solid #EEEFF2;
    }
    .path_switch{text-align: left;margin-bottom:20px;}
    .path{
            margin-bottom: 7px; display: flex; align-items: center; justify-content: space-between;
            .title{
                font-size:16px; font-weight:bold; color: #333333; border-left:4px solid #b21111; padding-left: 12px;
            }
        }
    .table_path{ flex: 1; box-shadow:0px 0px 10px rgba(94,94,94,0.16); border-radius:3px; width: 100%; padding: 8px 10px;  }
    .el-icon-refresh{margin-right:10px;cursor: pointer;color:#F9A602;font-weight: 600;}
    .gradeSection{width:700px;flex: 1;display: flex;flex-direction: column;}
    // .starList{margin-bottom:10px;}
    .starTableList .gradeStar{position: relative;top:5px;float: left;}
    .gradeStar{margin-right: 10px;margin-bottom:10px;}
</style>
<script>
    export default {
        components:{
        },
        data(){
            return{
                radioGrade:0
            }
        },
        created(){
            this.postFunc("/erp/system.get.config",{key:"SALE_DISCOUNT"},res=>{
                this.radioGrade = res.data.data.status;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        methods:{
            gradeChange(val){
                this.postFunc("/erp/system.set.config",{key:"SALE_DISCOUNT",status:val,value:111},()=>{
                    this.tip("操作成功","success")
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
        }
    }
</script>
